const sharedPaths = require('@lettucegrow/atoms.utils.constants')?.paths;

const { STATIC_URL = 'https://static.lettucegrow.com' } = process.env;

const paths = {
  ...sharedPaths,
  // PDF Links
  GROWING_GUIDE_PDF: STATIC_URL + '/growing-guide.pdf',
  ASSEMBLY_GUIDES_PDF: STATIC_URL + '/assembly-guides.pdf',
  PANTRY_SHOPPING_LIST_PDF: STATIC_URL + '/pantry.pdf',
  CLIMATE_GUIDE_PDF: STATIC_URL + '/fall-climate-guide.pdf',
};

module.exports = paths;
